import React from 'react';
import { Route } from 'react-router-dom';
import Analytics from 'components/Pages/Analytics';
import Dashboard from 'components/Pages/Dashboard';
import config from 'coeus.config';

const commonRoutes = () => {
    let routes = [];

    if (config.feature.public_access.enabled) {
        routes = [
            <Route
                key="dashboard"
                path="/dashboard"
                exact
                component={Dashboard}
            />,
            <Route key="page" path="/pages/:id" exact component={Analytics} />,
        ];
    }
    return routes;
};

export default commonRoutes;
